// removed by extract-text-webpack-plugin
module.exports = {"MultiSegmentSelect":"MultiSegmentSelect---6ANJ8","SegmentSelect":"SegmentSelect---2q6z2"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/CampaignWizards/TargetingInputArea/MultiSegmentSelect/style.styl
// module id = 2Fuj
// module chunks = 89